import { render } from "./Payment.vue?vue&type=template&id=9f312172&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=9f312172&scoped=true&lang=css"

import exportComponent from "/tmp/build_2d2f4584/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f312172"]])

export default __exports__